export function dataFormat(time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    //return parseTime(time, option);
  } else {
    return (
      d.getFullYear() +
      "年" +
      (d.getMonth() + 1) +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

export function dataFormatT(time) {
  time = +time * 1000;
  const d = new Date(time);

  return (
    d.getFullYear() + "/" + (d.getMonth() + parseInt(1)) + "/" + d.getDate()
  );
}

export function dataFormatF(time) {
  time = +time * 1000;
  const d = new Date(time);
  return (
    d.getFullYear() +
    "年" +
    (d.getMonth() + 1) +
    "月" +
    d.getDate() +
    "日" +
    d.getHours() +
    "时" +
    d.getMinutes() +
    "分"
  );
}

export function dataFormatS(time) {
  time = +time * 1000;
  const d = new Date(time);
  return (
    d.getFullYear() +
    "-" +
    (d.getMonth() + 1) +
    "-" +
    d.getDate() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes()
  );
}

export const getRandom = (n, m) => {
  return Math.floor(Math.random() * (m - n)) + n;
};

export function trim(str) {
  return String.prototype.trim.call(str);
}

export function isType(arg, type) {
  return Object.prototype.toString.call(arg) === "[object " + type + "]";
}

export function isWeixin() {
  return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
}

export function parseQuery() {
  const res = {};

  const query = (location.href.split("?")[1] || "")
    .trim()
    .replace(/^(\?|#|&)/, "");

  if (!query) {
    return res;
  }

  query.split("&").forEach((param) => {
    const parts = param.replace(/\+/g, " ").split("=");
    const key = decodeURIComponent(parts.shift());
    const val = parts.length > 0 ? decodeURIComponent(parts.join("=")) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });
  return res;
}

/**
 * 客户端图片压缩：把图片压到 maxSizeKB 以内（默认 100KB）
 * 原理：Canvas drawImage + toBlob('image/jpeg', quality) 有损压缩
 * 策略：先按 maxSide 限制最长边，再从 quality 0.9 递减到 minQuality，
 *       仍不达标则把尺寸缩到 0.7 倍重来，直到达标或尺寸过小（兜底返回当前最优结果）
 *
 * @param {File|Blob} file 原始图片文件
 * @param {Object} [options]
 * @param {number} [options.maxSizeKB=100]   目标体积（KB）
 * @param {number} [options.maxSide=1280]    初始最长边（像素）
 * @param {number} [options.minQuality=0.4]  最低压缩质量
 * @returns {Promise<File>} 压缩后的 File（统一为 image/jpeg）
 */
export function compressImage(file, options = {}) {
  const {
    maxSizeKB = 100,
    maxSide = 1280,
    minQuality = 0.4,
  } = options;

  // 已经足够小，直接原样返回
  if (file.size <= maxSizeKB * 1024) {
    return Promise.resolve(file);
  }

  // 1. 解码为 Image（createObjectURL 比 FileReader 快且省内存）
  const loadImage = (src) =>
      new Promise((resolve, reject) => {
        const img = new Image();
        const url = URL.createObjectURL(src);
        img.onload = () => {
          URL.revokeObjectURL(url);
          resolve(img);
        };
        img.onerror = () => {
          URL.revokeObjectURL(url);
          reject(new Error("图片解码失败（可能是不支持的格式，如 HEIC）"));
        };
        img.src = url;
      });

  // 2. canvas.toBlob 的 Promise 封装
  const canvasToBlob = (canvas, quality) =>
      new Promise((resolve) => {
        canvas.toBlob(
            (blob) => resolve(blob),
            "image/jpeg",
            quality
        );
      });

  return loadImage(file).then((img) => {
    // 初始尺寸：等比缩放到 maxSide 内
    let scale = Math.min(
        maxSide / img.naturalWidth,
        maxSide / img.naturalHeight,
        1
    );
    let width = Math.max(1, Math.round(img.naturalWidth * scale));
    let height = Math.max(1, Math.round(img.naturalHeight * scale));

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // 防止极端大图死循环：尺寸/质量/次数三重兜底
    const MAX_LOOP = 10;
    const MIN_SIDE = 200; // 尺寸低于该值就不再缩，直接兜底返回

    let lastBlob = null;

    return (async function loop() {
      for (let i = 0; i < MAX_LOOP; i++) {
        canvas.width = width;
        canvas.height = height;
        // 白底填充：PNG 透明区域转 JPEG 时避免变黑
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, width, height);
        ctx.drawImage(img, 0, 0, width, height);

        // quality 阶梯：0.9 → 0.75 → 0.6 → ... 最低 minQuality
        for (
            let q = 0.9;
            q >= minQuality;
            q = +(q - 0.15).toFixed(2)
        ) {
          const blob = await canvasToBlob(canvas, q);
          if (blob) {
            lastBlob = blob;
            if (blob.size <= maxSizeKB * 1024) {
              return blobToFile(blob, file);
            }
          }
        }

        // quality 到底还不达标：尺寸缩 0.7 倍再战
        if (Math.min(width, height) <= MIN_SIDE) {
          // 尺寸过小，不再缩，返回当前最优（可能略超目标）
          return lastBlob
              ? blobToFile(lastBlob, file)
              : Promise.reject(new Error("压缩失败"));
        }
        width = Math.max(1, Math.round(width * 0.7));
        height = Math.max(1, Math.round(height * 0.7));
      }
      return lastBlob
          ? blobToFile(lastBlob, file)
          : Promise.reject(new Error("压缩失败"));
    })();
  });
}

// Blob -> File，文件名统一改成 .jpg
function blobToFile(blob, originFile) {
  const baseName = (originFile && originFile.name ? originFile.name : "photo")
      .replace(/\.\w+$/, "");
  return new File([blob], `${baseName || "photo"}.jpg`, {
    type: "image/jpeg",
    lastModified: Date.now(),
  });
}
